import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import EmailIcon from "@mui/icons-material/Email";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import PaymentsIcon from "@mui/icons-material/Payments";
import PersonIcon from "@mui/icons-material/Person";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import PublicIcon from "@mui/icons-material/Public";
import RepeatIcon from "@mui/icons-material/Repeat";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import { Box, Divider, Grid, Paper, Typography, useTheme, Tooltip } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useLocation, useParams } from "react-router-dom";
import apiService from "../Services/api.service";
import AddStage from "../components/AddStage";
import PageLoader from "../components/Loader";
import { TimelineCard } from "../components/TimeLineCard";
import { useToast } from "../components/Toast";
import { useMention } from "../context/MentionContext";
const EngagementDetail = () => {
  const theme = useTheme();
  const [engagement, setEngagement] = useState(null);
  const [stages, setAvailableStages] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const timeline = engagement?.timeline || [];
  const location = useLocation();
  const { id: doctorId } = useParams();

  const token = localStorage.getItem("token");
  const { mentions, resetMentions } = useMention();

  const Toast = useToast();
  const [doctorDetails, setDoctorDetails] = useState({
    doctorName: "",
    docMobile: "",
    city: "",
    state: "",
    email: "",
  });
  const [subDetails, setSubDetails] = useState([]);

  const fetchEngagement = async () => {
    try {
      const res = await apiService.getDoctorEngagement(doctorId, token);
      setEngagement(res.data.engagement);
      if (res.data) {
        setAvailableStages(res.data.stages);
      }
    } catch (err) {
      Toast.error("Error fetching  data");
      console.error("Error fetching engagement:", err);
    }
  };

  const getDoctorDetails = async (doctorId) => {
    try {
      setIsLoader(true);
      const details = await apiService.fetchDoctorDetails(doctorId, token);
      const subscription = await apiService.getSubscriptionsByDoctor(
        doctorId,
        token
      );
      setSubDetails(subscription.data);
      setDoctorDetails({
        doctorName: details.name,
        docMobile: details.mobile,
        city: details.clinics[0].city,
        state: details.clinics[0].state,
        email: details.clinics[0].email,
      });
    } catch (error) {
      Toast.error("Error fetching  doctor details");
      console.error("Error in getDetails: ", error);
    } finally {
      setIsLoader(false);
    }
  };
  const extractMentionedUsernames = (text = "") => {
    const matches = text.match(/@([\w.-]+)/g) || [];
    return matches.map((m) => m.substring(1));
  };

  const addNote = async (engagementId, text) => {
    try {
      setIsLoader(true);

      const mentionedUsernames = extractMentionedUsernames(text);

      const taggedUsers = mentions.filter((u) =>
        mentionedUsernames.includes(u.username)
      );

      await axios.post(
        `${process.env.REACT_APP_API_HOST_URL}/ops/v1/engagement/timeline/addNote/${doctorId}`,
        {
          engagementId,
          text,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (taggedUsers.length > 0) {
        await Promise.all(
          taggedUsers.map((user) =>
            apiService.addTag({
              receiverId: user._id,
              module: "Dashboard",
              redirectUrl: `/dashboard/engagementTracker/${doctorId}`,
              message: `You were tagged in an engagement note of ${doctorDetails.doctorName}`,
              token,
            })
          )
        );
      }

      resetMentions();
      fetchEngagement();
    } catch (error) {
      Toast.error("Something went wrong. Unable to add note");
      console.error("Error in add note:", error);
    } finally {
      setIsLoader(false);
    }
  };

  const changeTimelinestatus = async (engagementId, newStatus) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API_HOST_URL}/ops/v1/engagement/timeline/update/${doctorId}`,
        {
          engagementId,
          newStatus,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      fetchEngagement();
    } catch (error) {
      Toast.error("Something went wrong.Unable to change status");
      console.error("Error in change status: ", error);
    }
  };
  useEffect(() => {
    if (doctorId) {
      getDoctorDetails(doctorId);
      fetchEngagement();
    }
  }, [doctorId]);
  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-GB"); // en-GB = DD/MM/YYYY
  };

  const activeSubs = subDetails?.filter((sub) => sub.status === "active") || [];

  return (
    <Paper
      sx={{
        p: 4,
        borderRadius: 2,
        // background: "#F5F7FA",
      }}
    >
      {/* MAIN DETAILS CARD */}
      <Box
        sx={{
          p: 4,
          mb: 6,
          //  background: "#FFFFFF",
          borderRadius: 3,
          boxShadow: "0 1px 8px rgba(0,0,0,0.08)",
        }}
      >
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Engagement Details
        </Typography>
        <Divider sx={{ mb: 4 }} />

        {/* DOCTOR DETAILS SECTION */}
        <Typography variant="subtitle2" sx={{ mb: 2, color: "text.secondary" }}>
          Doctor Details
        </Typography>

        <Grid container spacing={3}>
          {[
            {
              icon: <PersonIcon />,
              label: "Name",
              value: doctorDetails.doctorName || "N/A",
            },
            {
              icon: <PhoneIphoneIcon />,
              label: "Mobile",
              value: doctorDetails.docMobile || "N/A",
            },
            {
              icon: <EmailIcon />,
              label: "Email",
              value: doctorDetails.email || "N/A",
            },
            {
              icon: <LocationCityIcon />,
              label: "City",
              value: doctorDetails.city || "N/A",
            },
            {
              icon: <PublicIcon />,
              label: "State",
              value: doctorDetails.state || "N/A",
            },
          ].map((item, index) => (
            <Grid item xs={12} sm={6} md={4} lg={2.4} key={index}>
              <Box display="flex" alignItems="flex-start" gap={2}>
                <Box
                  sx={{
                    width: 44,
                    height: 44,
                    borderRadius: "50%",
                    // background: "#E6F0FF",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {React.cloneElement(item.icon, { color: "primary" })}
                </Box>

                <Box>
                  <Typography variant="caption" color="text.secondary">
                    {item.label}
                  </Typography>
                  <Tooltip title={item.value} arrow>
  <Typography
    variant="subtitle1"
    fontWeight={600}
    noWrap
    sx={{
      maxWidth: 140,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      cursor: "pointer",
    }}
  >
    {item.value}
  </Typography>
</Tooltip>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>

        {/* SUBSCRIPTION SECTION */}
        <Box mt={5}>
          <Typography
            variant="subtitle2"
            sx={{ mb: 2, color: "text.secondary" }}
          >
            Active Subscription
          </Typography>

          <Box
            sx={{
              background: theme.palette.mode === "light" && "#F9FAFB",
              borderRadius: 3,
              p: 3,
              boxShadow: "inset 0 0 5px rgba(0,0,0,0.05)",
            }}
          >
            {activeSubs.length === 0 ? (
              <Typography color="text.secondary">
                No active subscription
              </Typography>
            ) : (
              activeSubs.map((sub) => {
                const price = sub.customPrice ?? sub.planSnapshot?.price;
                const latestPayment = sub.paymentRecords?.length
                  ? [...sub.paymentRecords].sort(
                      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
                    )[0]
                  : null;
                return (
                  <Grid container spacing={3} key={sub._id}>
                    {[
                      {
                        icon: <WorkspacePremiumIcon />,
                        label: "Plan Name",
                        value: sub.planName || "N/A",
                      },
                      {
                        icon: <CalendarMonthIcon />,
                        label: "End Date",
                        value: sub.endDate ? formatDate(sub.endDate) : "N/A",
                      },
                      {
                        icon: <RepeatIcon />,
                        label: "Billing Cycle",
                        value: sub.planSnapshot?.billingCycle || "N/A",
                      },
                      {
                        icon: <PaymentsIcon />,
                        label: "Payment Status",
                        value: latestPayment?.status || "N/A",
                      },
                      {
                        icon: <PaymentsIcon />,
                        label: "Price",
                        value: price ? `₹${price}` : "N/A",
                      },
                    ].map((item, idx) => (
                      <Grid item xs={12} sm={6} md={4} lg={2.4} key={idx}>
                        <Box display="flex" alignItems="flex-start" gap={2}>
                          <Box
                            sx={{
                              width: 44,
                              height: 44,
                              borderRadius: "50%",
                              background: "#FFF4E5",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {React.cloneElement(item.icon, {
                              color: "primary",
                            })}
                          </Box>

                          <Box>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              {item.label}
                            </Typography>
                            <Typography variant="subtitle1" fontWeight={600}>
                              {item.value}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                );
              })
            )}
          </Box>
        </Box>
      </Box>

      {/* SECTION DIVIDER */}
      <Divider sx={{ my: 6 }} />

      {/* TIMELINE CARD */}
      {engagement && (
        <TimelineCard
          title="Timeline"
          timelineData={timeline}
          initiallyVisible={1}
          getIconLetter={(entry) => entry.stage?.charAt(0).toUpperCase() || "S"}
          fields={[
            { key: "stage", label: "Title", variant: "subtitle1", bold: true },
            { key: "description", label: "Description" },
            {
              key: "clientSatisfaction",
              label: "Client Satisfaction",
              suffix: "/5",
            },
            { key: "feedback", label: "Feedback" },
            {
              key: "updatedByName",
              label: "Updated By",
            },
            {
              key: "timestamp",
              label: "Time",
              render: (value) => {
                const date = new Date(value);
                const hours = date.getHours();
                const minutes = date.getMinutes();
                const hour12 = hours % 12 || 12;
                const ampm = hours >= 12 ? "pm" : "am";
                return `${hour12}.${minutes
                  .toString()
                  .padStart(2, "0")} ${ampm}`;
              },
            },
          ]}
          dropdownOptions={[
            { value: "Started", label: "Started" },
            { value: "In Progress", label: "In Progress" },
            { value: "Closed", label: "Closed" },
            { value: "Blocked", label: "Blocked" },
          ]}
          dropdownKey="status"
          onDropdownChange={(value, entry) => {
            changeTimelinestatus(entry._id, value);
          }}
          handleAddNote={(id, noteInput, addedBy) => {
            addNote(id, noteInput);
          }}
        />
      )}

      {/* ADD NEW STAGE */}
      <Box mt={4}>
        <AddStage
          setIsLoader={setIsLoader}
          doctorName={doctorDetails.doctorName}
          doctorId={doctorId}
          stages={stages}
          fetchEngagement={fetchEngagement}
          setAvailableStages={setAvailableStages}
        />
      </Box>

      {isLoader && <PageLoader />}
    </Paper>
  );
};

export default EngagementDetail;
